export default {
  NATIONAL_SIMPLE: 1,
  PRESUME_PROFIT: 2,
  REAL_PROFIT: 3
};
